module.exports = __webpack_public_path__ + "img/ico_light_3.2590d311.png";